import { mapGetters } from 'vuex'

export const upsell = {
	computed : {
		...mapGetters([ 'isLiteUser' ]),
	},
	methods : {
		maybeUpsell (event) {
			if (this.isLiteUser) {
				event.preventDefault()
				this.$bus.$emit('toggleProModal', {
					features   : [ 'omu' ],
					title      : 'OM University is only available for OptinMonster Pro users',
					tagline    : 'Get instant access to our library of expert courses, guides, video training and ebooks - plus unlock more powerful Pro features to skyrocket your subscribers, leads and sales!',
					buttonText : 'Upgrade to Pro and Unlock OM University',
					utmMedium  : this.utmMedium,
				})
			}
		},
	},
}
